module.exports = __webpack_public_path__ + "images/emoji/newspaper.9ef168c3486c4b19ae74.png";